import type { SoftphoneEvent } from 'Modules/softphone/services/EventService';

/**
 * The distinct legs present in an event buffer, in first-seen order.
 *
 * A conference room counts as a leg of its own: its `conferenceId` carries the
 * room's traffic as well as the participant REFERs tagged with it.
 */
export const getEventLegs = (events: SoftphoneEvent[]): string[] =>
  Array.from(
    new Set(
      events
        .map((event) => event.callId ?? event.conferenceId)
        .filter((id): id is string => Boolean(id))
    )
  );
